import React from "react";
import MainImage from "../../assets/Blackwomen/BWI30.jpg";
import Footer from "../../components/Footer";
import PastWork from "../../components/PastWord";
import NavLite from "../../components/NavLite";
import LaunchGlowUp from "../../components/LaunchGlowUp";
import BusinessGlowUp from "../../components/BusinessGlowUp";
import CEOGlowUp from "../../components/CEOGlowUp";
import AddOnServices from "../../components/AddOnServices";
import WebsiteDesignAddOns from "../../components/WebsiteDesignAddOns";
import WebsiteGlowUp from "../../components/WebsiteGlowUp";
import WebsiteGlowUpPro from "../../components/WebsiteGlowUpPro";
import Testimony from "../../components/Testimony";
import { Helmet } from "react-helmet";

function Services() {
  return (
    <div className="relative min-h-screen w-screen overflow-x-hidden bg-[#F6F3F1]">
      <Helmet>
        <title>
          Web Design & Branding Services for Women Entrepreneurs | Woaom Web
          Design
        </title>
        <meta
          name="description"
          content="Woaom Web Design offers custom websites, SEO, and branding services for women entrepreneurs in cities like Dallas, Houston, Austin, Atlanta, and New York City. Mobile-first, conversion-focused, and designed to elevate women-led brands."
        />
        <meta
          name="keywords"
          content="Dallas women entrepreneur web design, Houston TX branding for women founders, Austin custom websites for women-owned businesses, Atlanta web design services for women entrepreneurs, New York City women-led brand websites, Washington DC SEO for women entrepreneurs, Philadelphia women-owned business website design, Memphis TN web design for women-led startups, Baton Rouge custom websites for women entrepreneurs, Shreveport LA branding services for women founders, New Orleans web design agency for women-owned businesses, Macon GA women entrepreneurs website design, Augusta GA branding and website support for women, Baltimore women-owned business web design, professional web design packages for women entrepreneurs, mobile-first websites for women-led brands, conversion-focused design services for women in business, creative agency web design for female founders, custom branding for women entrepreneurs Texas, scalable web apps for women-led startups, SEO website strategy for women founders Atlanta, premium website templates for women-owned businesses, ecommerce setup for women entrepreneurs Houston, Flodesk website integration for female founders, service-based business website design for women in Dallas, modern branding for women-led businesses New York, one-page website packages for women entrepreneurs Philadelphia, professional business automation websites for women founders, strategic design and digital presence for women-led brands"
        />
      </Helmet>

      <section className="bg-[#F6F3F1]">
        <div
          className="relative h-auto bg-cover bg-center object-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <NavLite />
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10 md:py-28 py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-white italic text-3xl max-w-96 font-semibold">
                All Services and Packages
              </h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F6F3F1]">


           <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-4">
              <div className="mx-auto mb-8 w-full max-w-3xl text-center md:mb-12 lg:mb-10 flex flex-col items-center">
                <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">
                  Let's Build Something Bold
                </p>
                <h1 className="mb-4 text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                  Custom Web Design Services
                </h1>
                <p className="mx-auto mb-5 max-w-3xl text-sm text-gray-500 sm:text-xl md:mb-6 lg:mb-8">
                  More than just a website — we create visually stunning,
                  conversion-focused custom web designs tailored for women
                  entrepreneurs. Whether you need an elegant portfolio, a
                  boutique e-commerce site, or a dynamic business presence, our
                  designs combine beauty and function to help you stand out and
                  grow your brand with confidence.
                </p>
              </div>
            </div>
            <WebsiteGlowUp />
            <WebsiteGlowUpPro />
            <WebsiteDesignAddOns />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-4">
              <div className="mx-auto mb-8 w-full max-w-3xl text-center md:mb-12 lg:mb-6 flex flex-col items-center">
                <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">
                  Let's Build Something Bold
                </p>
                <h1 className="mb-4 text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                  Custom Web Application Services
                </h1>
                <p className="mx-auto mb-5 max-w-3xl text-sm text-gray-500 sm:text-xl md:mb-6 lg:mb-8">
                  Go beyond a basic website. We craft high-converting,
                  custom-coded web platforms using React, Tailwind, and
                  Firebase, designed specifically for women entrepreneurs who
                  are building bold, brilliant businesses like online education
                  platforms, wellness apps, and dynamic membership sites.
                </p>
              </div>
            </div>

            <LaunchGlowUp />

            <BusinessGlowUp />

            <CEOGlowUp />

            <AddOnServices />

           
          </div>
          <PastWork />
          <Testimony />
        </section>
        <Footer />
      </section>
    </div>
  );
}

export default Services;
